<template>
  <mirrors-redirectors-container />
</template>

<script>
  import { MirrorsRedirectorsContainer, } from '@/modules/mirrors-redirectors'

  export default {
    components: {
      MirrorsRedirectorsContainer,
    },
  }
</script>
